import { t } from '@/i18n';
import { BaladaAppType } from '@/model';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  title: z.string().min(1, t('pages.application_balada_app.components.balada_app_edit_modal.schema.required')),
  identifier: z
    .string()
    .min(1, t('pages.application_balada_app.components.balada_app_edit_modal.schema.required'))
    .max(20, t('pages.application_balada_app.components.balada_app_edit_modal.schema.identifier_max')),
  type: z.nativeEnum(BaladaAppType, {
    errorMap: () => ({ message: t('pages.application_balada_app.components.balada_app_edit_modal.schema.required') }),
  }),
  source_url: z.string().min(1, t('pages.application_balada_app.components.balada_app_edit_modal.schema.required')),
  file: z
    .any()
    .refine(
      file => !file || ACCEPTED_IMAGE_TYPES.includes(file.type),
      t('pages.application_balada_app.components.balada_app_edit_modal.schema.invalid_file'),
    )
    .optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
